import React from 'react';
import PropTypes from 'prop-types';
import SkeletonTypography from '../Skeleton/Typography';
import FuzzySearchInputSkeleton from '../FuzzySearchInput/FuzzySearchInputSkeleton';
import times from 'lodash/times';
import { Wrapper, AccountSearch, AccountListSkeleton, AccountListItem, AccountListItemText } from './styles';
export function AccountPickerSkeleton(props) {
  var _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? 'Accounts loading...' : _props$placeholder,
      accountSearchProps = props.accountSearchProps;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(AccountSearch, Object.assign({
    as: FuzzySearchInputSkeleton,
    placeholder: placeholder
  }, accountSearchProps)), /*#__PURE__*/React.createElement(AccountListSkeleton, null, times(5, function (i) {
    var skeletonWidth = i % 2 === 0 ? 220 : 170;
    return /*#__PURE__*/React.createElement(AccountListItem, {
      key: i
    }, /*#__PURE__*/React.createElement(AccountListItemText, {
      primary: /*#__PURE__*/React.createElement(SkeletonTypography, {
        style: {
          maxWidth: "".concat(skeletonWidth, "px")
        }
      })
    }));
  })));
}
AccountPickerSkeleton.propTypes = {
  placeholder: PropTypes.string,
  accountSearchProps: PropTypes.object
};
export default AccountPickerSkeleton;